import { render, staticRenderFns } from "./EditorCitationsManagementTab_CitationCard.vue?vue&type=template&id=9c5b2d2c"
import script from "./EditorCitationsManagementTab_CitationCard.vue?vue&type=script&lang=ts"
export * from "./EditorCitationsManagementTab_CitationCard.vue?vue&type=script&lang=ts"
import style0 from "./EditorCitationsManagementTab_CitationCard.vue?vue&type=style&index=0&id=9c5b2d2c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports